<div class="ticketHeaderForm">
  <div class="sa-ticket-header-title-bar">
    <div class="ticket-header-subject">
      <div class="text-input-control">
        <input
          [(ngModel)]="ticket.title"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="setDirty()"
          [ngClass]="{ 'has-error': isChanged && !isValid() }"
          (blur)="setDirty()"
          class="text-input-field ng-pristine ng-untouched ng-valid-maxlength ng-not-empty ng-valid ng-valid-required"
          placeholder="{{ (editable ? 'ticket_Edit_Subject_Placeholder' : 'ticketList_Subject_Placeholder') | xsI18n }}"
          [disabled]="!editable"
          maxlength="100"
        />
      </div>
    </div>

    <!-- Header icons -->
    <div class="edit-ticket-header-icons" *ngIf="isLicensed">
      <div
        [matTooltip]="'ssp_NewNote_tooltip' | xsI18n"
        [matTooltipPosition]="'above'"
        matTooltipClass="xsight-mat-tooltip"
        class="add-note-button hd-icon hd-icon-note hide-mobile"
        *ngIf="!isNew()"
        (click)="addActivity(1)"
      ></div>

      <input id="file" name="file" (change)="addAttachment($event)" type="file" style="display: none" />
      <label for="file">
        <div
          [matTooltip]="'ssp_NewAttachment_tooltip' | xsI18n"
          [matTooltipPosition]="'above'"
          matTooltipClass="xsight-mat-tooltip xsight-mat-tooltip-space"
          class="add-attachment-button hd-icon hd-icon-attachment"
        ></div>
      </label>
    </div>
  </div>

  <div class="sa-ticket-header-group" *ngIf="isNew()">
    <soti-select
      class="group-dropdown-select"
      *ngIf="showGroupsDropdown()"
      [(ngModel)]="ticket.groupId"
      [ngModelOptions]="{ standalone: true }"
    >
      <soti-option class="ticketHeaderGroupOption" [value]="group.groupId" *ngFor="let group of groups">{{
        group.groupName
      }}</soti-option>
    </soti-select>
  </div>

  <div class="sa-ticket-header-values-bar" *ngIf="!isNew()">
    <div class="sa-ticket-header-details">
      <div class="sa-ticket-header-ticket-id">{{ ticket.shortGroupName }}-{{ ticket.ticketId }}</div>
      <div class="sa-ticket-header-group-name">
        <span class="list-separator"></span>
        <span class="hd-icon-group icon-md group-icon"></span>
        <span class="group-name" sa-ellipsis [fullText]="groupName">{{ groupName }}</span>
        <span class="list-separator"></span>
      </div>
      <div class="hd-icon" [class]="getTicketStatus().glyphicon"></div>
      <div class="ssp-ticket-header-status-caption">{{ getTicketStatus().caption | xsI18n }}</div>
    </div>

    <div class="sa-ticket-header-dates">
      <div class="sa-ticket-header-dates-updated" *ngIf="ticket.updateDate">
        <label class="sa-ticket-header-dates-updated-label">{{ 'ticket_Updated_On_Caption' | xsI18n }}</label>
        <div class="sa-ticket-header-dates-updated-value">
          <xs-updating-time [time]="ticket.updateDate" [short]="true"></xs-updating-time>
        </div>
      </div>
      <div class="sa-ticket-header-dates-created" *ngIf="ticket.creationDate">
        <label class="sa-ticket-header-dates-created-label">{{ 'ticket_Created_On_Caption' | xsI18n }}</label>
        <div class="sa-ticket-header-dates-created-value">
          <xs-updating-time [time]="ticket.creationDate" [short]="true"></xs-updating-time>
        </div>
      </div>
    </div>
  </div>
</div>
